import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { t } from '../../../../modules/infra/i18n';
import withHandlers from 'recompose/withHandlers';
import withProps from 'recompose/withProps';
import { withRouter } from 'react-router';
import { reduxForm } from 'redux-form';
import Joi from 'joi-full';
import Loan from '../components/Loan';
import withNotifications from '../../../common/withNotifications';
import { syncValidateData } from '../../../common/validator';
import fetchOnUpdate from '../../../common/decorators/fetchOnUpdate';

import {
  fetchShopLoan,
  createShopLoan,
  updateShopLoan,
} from '../actions';
import {
  getLoan,
  getLoanAmountOwed,
  getLoanDetailHistory,
} from '../reducers/loan';
import withDateFormat from '../../../auth/utils/withDateFormat';

const mapStateToProps = (state, props) => {
  const shopId = props.params.id;
  const shop = state.admin.shops.byId[shopId];
  return {
    shopId,
    currency: shop && shop.currency,
    initialValues: getLoan(state),
    loanAmountOwed: getLoanAmountOwed(state),
    loanDetailHistory: getLoanDetailHistory(state),
  };
};

const mapDispatchToProps = {
  fetchShopLoan,
  createShopLoan,
  updateShopLoan,
};

const addCreateAndUpdateHanders = withHandlers({
  update: props => data => props.updateShopLoan(props.shopId, data),
  create: props => data => props.createShopLoan(props.shopId, data),
});

const addHandlers = withHandlers({
  onSubmit: props => (data) => {
    if (props.initialValues) {
      return props.update(data);
    }

    return props.create(data);
  },
});

const prepareFetchParams = withProps(props => ({
  params: {
    shopId: props.shopId,
  },
  actions: {
    shopFetch: props.fetchShopLoan,
  },
}));

const fetch = fetchOnUpdate(['shopId'], (params, actions) => actions.shopFetch(params.shopId));

const schema = {
  loanAmountBorrowed: Joi.number().min(0).required(),
  loanRepaymentPercentage: Joi.number().min(0).max(50).required(),
};
const LOAN_FORM = 'loanForm';
const form = reduxForm({
  form: LOAN_FORM,
  enableReinitialize: true,
  validate: values => syncValidateData(values, schema),
  onSubmitSuccess: (_values, _dispatch, props) => {
    props.addNotification({
      title: t('customers:edit_details.success_notification_title'),
      level: 'success',
      message: t('customers:edit_details.success_notification_message'),
    });
  },
});


const LoanContainer = compose(
  withDateFormat(),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withNotifications,
  addCreateAndUpdateHanders,
  addHandlers,
  form,
  prepareFetchParams,
  fetch,
);

export default LoanContainer(Loan);
